import {
  GET_DETAIL_TABLE_EXCO_PUSAT,
  GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  GET_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  POST_DETAIL_TABLE_EXCO_PUSAT,
  POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  POST_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  PATCH_DETAIL_TABLE_EXCO_PUSAT,
  PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  DELETE_DETAIL_TABLE_EXCO_PUSAT,
  DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  POST_LOCK_UNLOCK_EXCO,
  POST_LOCK_UNLOCK_EXCO_SUCCESS,
  POST_LOCK_UNLOCK_EXCO_FAIL
} from "./actionTypes";
import { API } from "../../API/api";

// get exco table
export const getDetailTableExcoPusat = (id) => (dispatch) => {
  dispatch({
    type: GET_DETAIL_TABLE_EXCO_PUSAT,
  });

  const request = API.getDetailTableExco(id);
  return request.then(
    (response) => dispatch(getDetailTableExcoPusatSuccess(response.data)),
    (err) => dispatch(getDetailTableExcoPusattFail(err))
  );
};

export const getDetailTableExcoPusatSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const getDetailTableExcoPusattFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_DETAIL_TABLE_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// post exco table
export const postPengurus = (data) => (dispatch) => {
  dispatch({
    type: POST_DETAIL_TABLE_EXCO_PUSAT,
  });

  const request = API.postPengurus(data);
  return request.then(
    (response) => dispatch(postPengurusSuccess(response.data)),
    (err) => dispatch(postPengurustFail(err))
  );
};

export const postPengurusSuccess = (data) => (dispatch) => {
  return dispatch({
    type: POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const postPengurustFail = (data) => (dispatch) => {
  return dispatch({
    type: POST_DETAIL_TABLE_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// patch exco table
export const patchPengurus = (id, data) => (dispatch) => {
  dispatch({
    type: PATCH_DETAIL_TABLE_EXCO_PUSAT,
  });

  const request = API.patchPengurus(id, data);
  return request.then(
    (response) => dispatch(patchPengurusSuccess(response.data)),
    (err) => dispatch(patchPengurusFail(err))
  );
};

export const patchPengurusSuccess = (data) => (dispatch) => {
  return dispatch({
    type: PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const patchPengurusFail = (data) => (dispatch) => {
  return dispatch({
    type: PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// delete exco table
export const deletePengurus = (id) => (dispatch) => {
  dispatch({
    type: DELETE_DETAIL_TABLE_EXCO_PUSAT,
  });

  const request = API.deletePengurus(id);
  return request.then(
    (response) => dispatch(deletePengurusSuccess(response.data)),
    (err) => dispatch(deletePengurusFail(err))
  );
};

export const deletePengurusSuccess = (data) => (dispatch) => {
  return dispatch({
    type: DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const deletePengurusFail = (data) => (dispatch) => {
  return dispatch({
    type: DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// GET USER DETAIL exco table
export const getDetailPengurus = (id) => (dispatch) => {
  dispatch({
    type: GET_USER_DETAIL_TABLE_EXCO_PUSAT,
  });

  const request = API.getDetailPengurus(id);
  return request.then(
    (response) => dispatch(getDetailPengurusSuccess(response.data)),
    (err) => dispatch(getDetailPengurusFail(err))
  );
};

export const getDetailPengurusSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const getDetailPengurusFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL,
    payload: data,
  });
};


// post lock unlock exco
export const postLockUnlock = (data) => (dispatch) => {
  dispatch({
    type: POST_LOCK_UNLOCK_EXCO,
  });

  const request = API.lockUnlockExco(data);
  return request.then(
    (response) => dispatch(postLockUnlockSuccess(response.data)),
    (err) => dispatch(postLockUnlockFail(err))
  );
};

export const postLockUnlockSuccess = (data) => (dispatch) => {
  return dispatch({
    type: POST_LOCK_UNLOCK_EXCO_SUCCESS,
    payload: data,
  });
};

export const postLockUnlockFail = (data) => (dispatch) => {
  return dispatch({
    type: POST_LOCK_UNLOCK_EXCO_FAIL,
    payload: data,
  });
};